import { render } from "./MatchingView.vue?vue&type=template&id=7054b9e0&scoped=true"
import script from "./MatchingView.vue?vue&type=script&lang=js"
export * from "./MatchingView.vue?vue&type=script&lang=js"

import "./MatchingView.vue?vue&type=style&index=0&id=7054b9e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7054b9e0"]])

export default __exports__